import GaodeMap from './amap/';
// import GaodeMapV1 from './amap/';
import GaodeMapV2 from './amap2/';
import Earth from './earth/';
// import GaodeMapV2 from './amap2/';
import Map from './map/';
import Mapbox from './mapbox/';
import { Version } from './version';

export { Version, GaodeMap, GaodeMapV2, Mapbox, Map, Earth };
// export { GaodeMap, GaodeMapV2, Mapbox, Map };
// export { Map };
